import { useSelector } from 'react-redux'
import { ConceptValues } from '../../../../../../../types/Survey/Analysis/Concept'
import { Element, Type } from '../../../../../../../types/Survey/Element'
import { DynamicText, OrganizationUnitCooperationSelection } from '../../../../../../../types/Survey/Answer/Element'
import props from '../../../../../../../redux/props'
import { Survey } from '../../../../../../../types/Survey/Survey'
import { OrganizationUnit } from '../../../../../../../types/OrganizationUnit'
import TableItem, { TableItemRow } from '../../../Summary/TableItem'

type Props = {
  survey: Survey
  values: ConceptValues
}

const OtherInformation: React.FC<Props> = ({ survey, values }) => {
  const t = useSelector((s) => s[props.TRANSLATION])

  const getAnswer = <T,>(element: Element): T => {
    if (!values.managerAnswer) return null
    const elem = values.managerAnswer.elements.find((e) => e.uuid === element.uuid)
    return elem as T
  }

  const getUnit = (uuid: string): OrganizationUnit => {
    const unit = survey.context.organizationUnitList.find((u) => u.uuid === uuid)
    return unit
  }

  const getElement = (e: Element) => {
    if (e.type === Type.DYNAMIC_TEXT) {
      const answer = getAnswer<DynamicText>(e)
      if (!answer || answer.textAnswers.length === 0) return null
      return (
        <TableItem
          title={e.title}
          doRound
          items={answer.textAnswers.map((a, i) => (
            <TableItemRow key={a.uuid} title={a.value} values={[]} />
          ))}
        />
      )
    } else if (e.type === Type.ORGANIZATION_UNIT_COOPERATION_SELECTION) {
      const answer = getAnswer<OrganizationUnitCooperationSelection>(e)
      if (!answer || !Array.isArray(answer?.organizationUnitPrioSelectionList) || answer.organizationUnitPrioSelectionList.length === 0) return null

      return (
        <TableItem
          title={e.title}
          doRound
          items={answer.organizationUnitPrioSelectionList
            .sort((a, b) => a.priority - b.priority)
            .map((entry, i) => (
              <TableItemRow
                key={entry.organizationUnitUUID}
                title={`${t.survey.analysis.calculation.values.organizationUnitPrioSelectionList.priority} ${entry.priority}`}
                values={[{ value: getUnit(entry.organizationUnitUUID).name }]}
              />
            ))}
        />
      )
    }

    return null
  }

  const elements = values.managerSurvey.elements.map(getElement).filter((e) => e !== null)

  return (
    <div className="mt-3">
      <div className="font-bold">{t.survey.analysis.calculation.values.moreInformation.headline}</div>
      <div className="flex flex-col gap-3">{elements.length > 0 ? elements : t.survey.analysis.calculation.values.empty}</div>
    </div>
  )
}

export default OtherInformation
